export function getOpenedItems(itemsCount, preOpenedIndex) {
    return new Array(itemsCount).fill(false).map((_, index) => index === preOpenedIndex);
}
